import { connect } from "react-redux";
import HotoApproval from "./hotoApproval";
import { bindActionCreators } from "redux";
import { getHotoDetails,updateHotoStatus } from "services/redux/maintenance/hoto/action";
const mapStateToProps = (state) => ({
  hotoDetails: state.HotoReducer.hotoDetails,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getHotoDetails,
      updateHotoStatus
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(HotoApproval);
